import { Cancel } from '@mui/icons-material';
import { ComponentProps } from 'react';

import { LoadingButton } from 'src/components/common/buttons/LoadingButton';

export const CancelLoadingButton = (props: ComponentProps<typeof LoadingButton>): JSX.Element => {
    const {
        Icon = Cancel,
        'aria-label': ariaLabel = 'cancel and reset changes',
        ...rest
    } = props;

    return (
        <LoadingButton {...rest} aria-label={ariaLabel} color="secondary" Icon={Icon} />
    );
};
